// extracted by mini-css-extract-plugin
export default {"row":"EventOfferPerShow_row__ZDNan","wrapper":"EventOfferPerShow_wrapper__qWHg-","item":"EventOfferPerShow_item__1IaYo"};